import { render, staticRenderFns } from "./case-detail.vue?vue&type=template&id=141b0363&scoped=true&"
import script from "./case-detail.vue?vue&type=script&lang=js&"
export * from "./case-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141b0363",
  null
  
)

export default component.exports